import store from './index'
import toast from '@/utils/toast'
import generateID from '@/utils/generateID'
import { deepCopy } from '@/utils/utils'

export default {
    state: {
        copyData: null, // 复制粘贴剪切
        isCut: false,
    },
    mutations: {
        copy(state) {
            if (!state.curComponent) return
            let copyData = deepCopy(state.curComponent)
            state.componentData.forEach((e, index) => { e.FormOrder = index })
            copyData.FormOrder = state.componentData.length
            if (copyData.BlockID !== undefined) {
                copyData.BlockID = 0
                copyData.FieldName = ''
            }
            if (copyData.FieldID !== undefined) {
                copyData.FieldID = 0
                copyData.FieldName = ''
            }
            state.copyData = {
                data: copyData,
                index: state.curComponentIndex,
            }
            state.isCut = false
        },

        paste(state) {
            if (!state.copyData) {
                toast('请选择组件')
                return
            }
            const data = state.copyData.data
            // data.FormOrder = generateID(store.state.componentData.length - 1)
            store.commit('addComponent', { component: deepCopy(data) })
            if (state.isCut) {
                state.copyData = null
            }
        },
        pagePaste(state) {
            if (!state.copyData) {
                toast('请选择组件')
                return
            }
            const data = state.copyData.data
            let copyData = deepCopy(data)
            if (copyData.hasOwnProperty('children') && copyData.children.length > 0) {
                copyData.children.forEach(e => {
                    e.BlockID = 0
                })
            }
            console.log(data)
            // data.FormOrder = generateID(store.state.componentData.length - 1)
            store.commit('addPageComponent', { component: copyData })
            if (state.isCut) {
                state.copyData = null
            }
        },
        cut(state) {
            if (!state.curComponent) {
                toast('请选择组件')
                return
            }

            if (state.copyData) {
                const data = deepCopy(state.copyData.data)
                const index = state.copyData.index
                data.FormOrder = generateID()
                store.commit('addComponent', { component: data, index })
                if (state.curComponentIndex >= index) {
                    // 如果当前组件索引大于等于插入索引，需要加一，因为当前组件往后移了一位
                    state.curComponentIndex++
                }
            }

            store.commit('copy')
            store.commit('deleteComponent')
            state.isCut = true
        },
    },
}


// WEBPACK FOOTER //
// ./src/store/copy.js